import { APIClient } from '@frontend/api-utils';
import { SettingTemplateResult } from '@frontend/setting/types';

export class SSOTemplateClient extends APIClient {
    public static readonly endpoint = '/sso-api/v1';

    public static async fetchSSODataTemplates(): Promise<SettingTemplateResult> {
        const response = await this.fetch(`${this.endpoint}/sso-data-templates`);
        return await this.handleResponse<SettingTemplateResult>(response);
    }
}
